import { useIsAfterpayAppGiftCardFlow } from '../../state'

export const useShowProcessingModal = (): boolean => {
  const isAfterpayAppGiftCardFlow = useIsAfterpayAppGiftCardFlow()
  return !isAfterpayAppGiftCardFlow
}
